import * as keys from './keys';

const init = {
  loadProfileImage: false
};

const reducer = (state = init, action) => {
  switch (action.type) {
  case keys.PROFILE_IMAGE:
    return {
      ...state,
      loadProfileImage: action.payload
    };
  default:
    return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/userProfile/index.js